module.exports = __webpack_public_path__ + "static/media/sala_principal_8.bb9f7627.jpg";